import { Component } from '@angular/core';

@Component({
  selector: 'app-business-validation',
  templateUrl: './business-validation.component.html',
  styleUrls: ['./business-validation.component.css'],
})
export class BusinessValidationComponent {
  title1 = 'Admin Panel';
  title = 'Business Validation';
  class1 = 'profile-banner ';
  img1 = '../../../assets/images/logo.png';
}
